import messages from './cmsArchive.json' with { type: 'json' };

export const cmsArchiveEn: Readonly<typeof messages> = messages;
